(function() {
  'use strict';
  angular.module('common')
  .filter('taxIdStatus', [function() {
    return function(taxIdStatus) {
      return (taxIdStatus == 'APPROVED' || taxIdStatus == 'REJECTED') ?
              (taxIdStatus.substring(0,1) + taxIdStatus.substring(1).toLowerCase()) : 'Pending Approval';
    };
  }]).filter('taxIdValidationStatus', function() {
    var validationErrorText = {
      'teledent':'Not in Teledent',
      'dso': 'Tax Id is in use by DSO',
      'provider': 'Tax Id is in use by Provider'
    };
    var statusText = {
      'PENDING_TIN_APPROVAL' : 'Valid',
      'APPROVED' : 'Approved',
      'REJECTED' : 'Rejected'
    };
    var notValidated = 'Pending Tax Id Validation';
    var getValidationErrorText = function(type, val) {
      if (val !== 'VALID') {
        return  (val === 'INVALID' ? validationErrorText[type] : notValidated);
      }
    };
    return function(taxIdStatus, taxIdObject) {
      if (taxIdObject) {
        if (taxIdObject.status === 'APPROVED' || taxIdObject.status === 'REJECTED' ||
           (taxIdObject.teledentStatus === 'VALID' && taxIdObject.dsoStatus === 'VALID' && taxIdObject.providerStatus === 'VALID')) {
            return statusText[taxIdStatus];
        }else{
          let errorTexts = _.filter([getValidationErrorText('teledent',taxIdObject.teledentStatus),
                                      getValidationErrorText('dso',taxIdObject.dsoStatus),
                                      getValidationErrorText('provider',taxIdObject.providerStatus)],(t) => {
            return t !== undefined;
          });
          return errorTexts.indexOf(notValidated) > -1 ? notValidated   : errorTexts.join(", ");
        }
     }
    };
  }).filter('templateStatus', function(){
    return function (status) {
      if (status) {
        return status == 'COMPLETED' ? 'Completed' : 'Pending';
      }
    };
  });
})();
